import {useMutation, useQueryClient} from '@tanstack/react-query';

import {trustAccountActivityKeys} from '@/features/trust-accounts/hooks/useTrustAccountActivity';
// Direct path, not the feature barrel — the barrel re-exports hooks that import this module back.
import {invalidatePaymentInstructions} from '@/features/trust-accounts/utils/trust-account-invalidations.utils';
import {useApiClient} from '@/hooks';

import {paymentsApi} from '../api';

import type {CreatePaymentInstructionPayload} from '@sollapay/types';

export function useCreatePaymentInstructionMutation(trustAccountId: string) {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreatePaymentInstructionPayload) =>
      paymentsApi.createPaymentInstruction(client, trustAccountId, payload),
    onSuccess: () => {
      invalidatePaymentInstructions(queryClient, trustAccountId);
      queryClient.invalidateQueries({queryKey: trustAccountActivityKeys.all(trustAccountId)});
    }
  });
}
